import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import EmailMessage from "../components/EmailMessageComponent/EmailMessage.component";
import MachineMessage from "../components/MachineMessageComponent/machinemessage.component";
import FinalUserGrid from "../components/FinalUsersGrid/FinalUserGrid.component";
import { User } from "../utils/models/User";

const MarketingModulePage = () => {
    const { t } = useTranslation();
    const user = useSelector(selectUser)
    const context: IOutletContext = useOutletContext();
    const [users, setUsers] = useState<User[]>([])

    useEffect(() => {
        context.setState(t('Marketing'));
    }, [context, t]);

    useEffect(() => {
        const a = new User()
        a.name = 'Jordi'
        a.surname = 'Rovira'
        a.email = 'jordi.rovira@awayter.com'
        const b = new User()
        b.name = 'David'
        b.surname = 'Jové'
        b.email = 'david.jove@awayter.com'
        const c = new User()
        c.name = 'Euduard'
        c.surname = 'Martínez'
        c.email = 'eduard.martinez@awayter.com'
        const d = new User()
        d.name = 'Silvia'
        d.surname = 'Oliver'
        d.email = 'silvia.oliver@awayter.com'
        const e = new User()
        e.name = 'Roc'
        e.surname = 'Alzina'
        e.email = 'roc.alzina@awayter.com'
        const f = new User()
        f.name = 'Joan'
        f.surname = 'Muñoz'
        f.email = 'joan.muñoz@awayter.com'
        const g = new User()
        g.name = 'Albert'
        g.surname = 'Creuat'
        g.email = 'albert.creuat@awayter.com'
        const h = new User()
        h.name = 'Maria'
        h.surname = 'Soler'
        h.email = 'maria.soler@awayter.com'

        setUsers([a, b, c, d, e, f, g, h])
    }, [])

    return (
        <>

            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col p-1'>
                    <FinalUserGrid users={users} loading={false} onCopy={() => null} />
                </div>
                <div className='col-12 col-sm-5 p-1'>
                    <div className="mb-2">
                        <MachineMessage machine={null} token={user.token} onSavedText={() => null} />
                    </div>
                    <div className="mb-2">
                        <EmailMessage machine={null} token={user.token} onSavedText={() => null} showToastTimeOut={() => null} />
                    </div>
                </div>
            </div>

        </>
    )
}

export default MarketingModulePage;
